module.exports = __webpack_public_path__ + "img/gb-wls.0fc7895b.svg";